import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import capitalize from '@afosto/utils/string/capitalize';
import SuggestionFilter from '../../FiltersField/formatters/SuggestionFilter';

const OrderProgressStatusFilter = ({ suggestions, ...otherProps }) => {
  const intl = useIntl();

  const formattedSuggestions = suggestions
    .filter(suggestion => suggestion.value)
    .reduce(
      (acc, suggestion) => [
        ...acc,
        {
          label: intl.formatMessage({
            id: `orderProgressStatus.${suggestion.label}`,
            defaultMessage: capitalize(suggestion.label ?? ''),
            description: `order progress status ${suggestion.label}`,
          }),
          value: suggestion.value,
        },
      ],
      [],
    );

  return (
    <SuggestionFilter
      {...otherProps}
      getOptionSelected={(option, value) => value === option.value}
      getOptionLabel={option => {
        if (typeof option === 'object') {
          return option.label;
        }

        return intl.formatMessage({
          id: `orderProgressStatus.${option}`,
          defaultMessage: capitalize(option ?? ''),
          description: `order type type ${option}`,
        });
      }}
      suggestions={formattedSuggestions}
    />
  );
};

OrderProgressStatusFilter.propTypes = {
  suggestions: PropTypes.array,
};

OrderProgressStatusFilter.defaultProps = {
  suggestions: [],
};

export default OrderProgressStatusFilter;
